// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ApiServerDatabases } from '../models/index';
import {
  ApiServerDatabasesFromJSON,
  ApiServerDatabasesToJSON,
} from '../models/index';

export interface ServersServerNameDatabasesGetRequest {
  serverName: string;
  orchestra: string;
}

/**
 *
 */
export class V2ServersApi extends runtime.BaseAPI {
  /**
   * List the Aura database ids running on a server. multi_database is true when the server belongs to a multi-database cluster, and false for a single-database cluster or a legacy free single instance. database_ids is empty when the server is only hosting the internal system database. A sharded name such as neo4j-g000 is returned as the same Aura database id once.
   * List Aura databases on a server
   */
  async serversServerNameDatabasesGetRaw(
    requestParameters: ServersServerNameDatabasesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiServerDatabases>> {
    if (requestParameters['serverName'] == null) {
      throw new runtime.RequiredError(
        'serverName',
        'Required parameter "serverName" was null or undefined when calling serversServerNameDatabasesGet().',
      );
    }

    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling serversServerNameDatabasesGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['orchestra'] != null) {
      queryParameters['orchestra'] = requestParameters['orchestra'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/servers/{serverName}/databases`;
    urlPath = urlPath.replace(
      `{${'serverName'}}`,
      encodeURIComponent(String(requestParameters['serverName'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ApiServerDatabasesFromJSON(jsonValue),
    );
  }

  /**
   * List the Aura database ids running on a server. multi_database is true when the server belongs to a multi-database cluster, and false for a single-database cluster or a legacy free single instance. database_ids is empty when the server is only hosting the internal system database. A sharded name such as neo4j-g000 is returned as the same Aura database id once.
   * List Aura databases on a server
   */
  async serversServerNameDatabasesGet(
    requestParameters: ServersServerNameDatabasesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiServerDatabases> {
    const response = await this.serversServerNameDatabasesGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
